import { LastMedicalTreatmentConsentQuery } from '@dreryk/egabinet-patient-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { Link } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';

import { useMedicalTreatmentConsentCreateCommand } from './MedicalTreatmentConsentEnterAction.hooks';

export type MedicalTreatmentConsentEnterActionProps = {
   readonly patientId: number;
};

export const MedicalTreatmentConsentEnterAction = ({
   patientId,
}: MedicalTreatmentConsentEnterActionProps): JSX.Element => {
   const { loading, execute: enterConsent } = useMedicalTreatmentConsentCreateCommand({
      patientId: patientId,
      onSuccess: () => {
         refetchCqrsQuery(LastMedicalTreatmentConsentQuery);
      },
   });

   const onClick = (): void => {
      enterConsent();
   };

   return (
      <Link
         testId={'enterConsent'}
         label={patientConsentsAndAuthorizationsTranslationKeys.consent.enterConsent}
         onClick={onClick}
         disabled={loading}
      />
   );
};
